import { Input, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-dialog-footer',
  templateUrl: './dialog-footer.component.html',
  styleUrl: './dialog-footer.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'dialog-footer',
    '[class]': '"dialog-footer_" + justifyContent',
  },
})
export class DialogFooterComponent {
  @Input() justifyContent: 'space-between' | 'center' | 'start' | 'end' = 'space-between';
}
